import { Component, Inject, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SpokesmenService } from 'src/app/core/services/api/spokesmen.service';
import { Swal2 } from 'src/app/core/utils/swal2.util';
import { NewPersonComponent } from '../../new-person/new-person.component';
import { combineLatest, Observable, of } from 'rxjs';
import { PeopleService } from '../../../core/services/api/people.service';
import { map, tap, debounceTime, distinctUntilChanged, switchMap, filter } from 'rxjs/operators';
import { CargosService } from 'src/app/core/services/api/cargos.service';
import { CargosFormComponent } from 'src/app/pages/maintenance/media/cargos/form/cargos-form.component';

@Component({
    selector: 'app-asignar-voceros-cliente-form',
    templateUrl: './asignar-voceros-cliente-form.component.html',
    styleUrls: ['./asignar-voceros-cliente-form.component.scss']
})
export class AsignarVocerosClienteFormComponent implements OnInit {
    public loading: boolean = false;

    myForm = this.formBuilder.group({
        vocero_id: new FormControl<number | null>({ value: null, disabled: true }, [Validators.required]),
        filter: new FormControl<string | null>(null),
        cargo: new FormControl<number[] | null>(null, [Validators.required]),
        filterC: new FormControl<string | null>(null),
        observacion: new FormControl<string | null>(null),
    });

    vocero: any = {
        
        idVocero: null,
        observacion: null,
    }

    voceros: any[] = [];
    cargos: any[] = [];

    allVoceros: any[] = [];
    filteredVoceros: any[] = [];

    title = 'Agregar vocero';

    select$: Observable<any>

    filteredVoceros$: Observable<any[]>;

    constructor(
        public dialog: MatDialog,
        private formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<AsignarVocerosClienteFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { row: any, id: number, idCliente: number },
        private spokesmenService: SpokesmenService,
        private swal: Swal2,
        private peopleService: PeopleService,
        private cargosService: CargosService
    ) {
    }

    ngOnInit(): void {
        this.cargosService.getAll().subscribe((response: any) => {
            const { cargos } = response;
            this.cargos = cargos;
            if (this.data.row) {
                const raw = (this.data.row as any).idsCargo || (this.data.row as any).ids_cargo || (this.data.row as any).cargos;
                let selectedIds: number[] = [];
                if (Array.isArray(raw)) {
                    if (raw.length && typeof raw[0] === 'object') {
                        selectedIds = raw.map((r: any) => Number(r.id ?? r.idCargo ?? r.cargo_id)).filter((v: number) => !isNaN(v) && v > 0);
                    } else {
                        selectedIds = raw.map((v: any) => Number(v)).filter((v: number) => !isNaN(v) && v > 0);
                    }
                } else if (typeof raw === 'string') {
                    selectedIds = raw.split(',').map((n: string) => Number(n.trim())).filter((n: number) => !isNaN(n) && n > 0);
                } else if (typeof raw === 'number') {
                    selectedIds = [raw].filter(v => v > 0);
                }
                if (!selectedIds.length && typeof (this.data.row as any).cargo === 'string') {
                    const labels = (this.data.row as any).cargo.split(',').map((s: string) => s.trim()).filter((s: string) => !!s);
                    selectedIds = this.cargos
                        .filter(c => labels.includes(c.descripcion))
                        .map(c => c.id);
                }
                if (selectedIds.length) this.myForm.controls.cargo.setValue(selectedIds);
            }
        });
        if (this.data.row) {
            // console.log('edit row', this.data.row);
            this.title = 'Editar vocero';
            this.spokesmenService.getIdClienteVocero(this.data.row.id).subscribe((response: any) => {
                const cv = (response && (response.clienteVocero || response.data || response)) as any;
                // console.log('clienteVocero', cv);
                const setVocero = (persona: any) => {
                    if (!persona) return;
                    persona.completeName = `${persona.nombres || ''} ${persona.apellidos || ''}`.trim();
                    this.voceros = [persona];
                    this.myForm.controls.vocero_id.setValue(persona.id);
                    if (this.myForm.controls.vocero_id.disabled) {
                        this.myForm.controls.vocero_id.enable({ emitEvent: false });
                    }
                };
                if (cv?.vocero) {
                    setVocero(cv.vocero);
                } else if (cv?.idVocero) {
                    this.peopleService.getId(cv.idVocero).subscribe((persona: any) => setVocero(persona));
                }
                const idsFromDetail = this.extractCargoIds(cv);
                if (idsFromDetail.length) this.myForm.controls.cargo.setValue(idsFromDetail);
                if (cv && typeof cv.observacion !== 'undefined') {
                    this.myForm.controls.observacion.setValue(cv.observacion);
                }
            });

        } else {
            this.loadVoceros();
            // this.peopleService.getPersonasSelect().subscribe((response: any) => {
            //     const {data} = response;
            //     console.log('personas', data);
                
            //     this.voceros = data.map(vo => {
            //         vo.completeName = `${vo.nombres} ${vo.apellidos}`;
            //         return vo;                  
            //     });
            //     this.myForm.controls.vocero_id.enable({ emitEvent: false });
            // });
        }
    }

    private extractCargoIds(detail: any): number[] {
        if (!detail) return [];
        const raw = detail.idsCargo || detail.ids_cargo || detail.cargos;
        if (Array.isArray(raw)) {
            if (raw.length && typeof raw[0] === 'object') {
                return raw.map((r: any) => Number(r.id ?? r.idCargo ?? r.cargo_id)).filter((v: number) => !isNaN(v) && v > 0);
            }
            return raw.map((v: any) => Number(v)).filter((v: number) => !isNaN(v) && v > 0);
        }
        if (typeof raw === 'string') {
            return raw.split(',').map((n: string) => Number(n.trim())).filter((n: number) => !isNaN(n) && n > 0);
        }
        if (typeof raw === 'number') {
            return [raw].filter(v => v > 0);
        }
        return [];
    }

    setupFilteredVoceros() {
        this.filteredVoceros$ = this.myForm.get('filter').valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            filter(value => typeof value === 'string'),
            switchMap(value => {
                if (!value || value.length < 2) {
                    return of([...this.allVoceros.slice(0, 5), this.selectedVocero()].filter(v => v));
                }
                return this.searchVoceros(value);
            })
        );
    }

    selectedVocero() {
      const idVocero = this.myForm.controls.vocero_id.value;
      return this.allVoceros.find(v => v.id === idVocero) || null;
    }

    searchVoceros(value: string): Observable<any[]> {
        return of(this.allVoceros.filter(v => 
            v.label.toLowerCase().includes(value.toLowerCase())
        ).slice(0, 5));
    }

    loadVoceros() {
        combineLatest([
            this.peopleService.getPersonasSelect(true)
        ]).pipe(
            map(([personas]) => {
                const voceros = personas['data'];
                // console.log('personas', voceros);
                
                return voceros.map(vo => {
                    vo.isVoceroCliente = vo.tiposPersona === '2' || vo.tiposPersona === '1,2';
                    vo.completeName = `${vo.nombres} ${vo.apellidos}`;
                    return vo;
                });
            })
        ).subscribe(response => {
            this.voceros = response;
            // this.filteredVoceros = this.allVoceros.slice(0, 5);
            this.myForm.controls.vocero_id.enable();
        });
    }
    

    filterVoceros(value: string | null) {
        if (!value) {
            this.filteredVoceros = this.allVoceros.slice(0, 5);
        } else {
            this.filteredVoceros = this.allVoceros.filter(v => 
                v.label.toLowerCase().includes(value.toLowerCase())
            );
        }
    }

    onSubmit() {
        this.loading = true;
        const selectedIds: number[] = this.myForm.get('cargo')?.value || [];
        this.vocero = {
            idVocero: this.myForm.controls.vocero_id.value,
            idsCargo: selectedIds,
            cliente_id: this.data.idCliente,
            observacion: this.myForm.controls.observacion.value
        }
        let observable: Observable<any> | undefined = undefined
        
        if (this.data.row) {
            this.vocero.id = this.data.row.id;
            observable = this.spokesmenService.editClienteVoceros(this.vocero);
        } else {
            observable = this.spokesmenService.createClienteVoceros(this.vocero);
        }
        observable.subscribe((response: any) => {
            this.dialogRef.close(response);
            this.loading = false;
            this.swal.showToast(response.message, 'success');
        }, error => {
            if (error.status === 400) {
                this.error(error);
            }
            this.loading = false;
        });
    }

    changeVocero() {
        if (!!this.myForm.controls.vocero_id.value && this.myForm.controls.vocero_id.value != -1) {
            const person = this.voceros.find(el => el.id == this.myForm.controls.vocero_id.value);
            const ind = this.voceros.findIndex(el => el.id == this.myForm.controls.vocero_id.value);
            if (!person.isVoceroCliente) {
                this.dialog.open(NewPersonComponent, {
                    data: {
                        tipo: [2],
                        idCliente: null,
                        edit: !person.tiposPersona.includes('2'),
                        person
                    },
                    width: '600px'
                }).afterClosed().subscribe(res => {
                    if (res) {
                        res.completeName = res.nombres + ' ' + res.apellidos;
                        this.voceros[ind] = res;
                        this.myForm.controls.vocero_id.setValue(res.id);
                    } else {
                        this.myForm.controls.vocero_id.setValue(null);
                    }
                })
            }
        }
        if (this.myForm.controls.vocero_id.value == -1) {
            this.newPerson();
        }
    }

    error(error: any) {
        if (error.error.errors.idVocero) {
            this.swal.showToast(error.error.errors.idVocero[0], 'error');
        }
    }

    newPerson() {
        this.dialog.open(NewPersonComponent, {
            data: { tipo: [2], idCliente: null },
            width: '600px'
        }).afterClosed().subscribe(res => {
            if (res) {
                res.completeName = res.nombres + ' ' + res.apellidos;
                res.isVoceroCliente = res.tiposPersona === '2' || res.tiposPersona === '1,2';
                this.voceros.push(res);
                this.myForm.controls.vocero_id.setValue(res.id);
            } else {
                this.myForm.controls.vocero_id.setValue(null);
            }
        });
    }

    addCargo(row?) {
        const dialogRef = this.dialog.open(CargosFormComponent, {
            data: row,
            width: '500px'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.cargo) {
                const nuevoCargo = result.cargo;
                this.cargos.push(nuevoCargo);
                const seleccionActual = this.myForm.controls.cargo.value || [];
                if (!seleccionActual.includes(nuevoCargo.id)) {
                    this.myForm.controls.cargo.setValue([...seleccionActual, nuevoCargo.id]);
                }
                this.myForm.controls.filterC.setValue(null);
            }
        });
    }
}
